function initTooltips() {
	$('.default-tooltipster').tooltipster({
		maxWidth: 290,
		contentAsHTML: true,
		interactive: true,
		functionPosition: function (instance, helper, position) {
			$(helper.tooltip).addClass('no-contrast');
			position.coord.left = helper.geo.origin.offset.left - 20;
			return position;
		},
	});
}
